import React from 'react';
import { twMerge } from 'tailwind-merge';
export const Sidebar = props => {
    const { children, className } = props;
    return (React.createElement("div", { className: twMerge('flex flex-col w-64 min-w-64', className) },
        React.createElement("div", { className: "flex-1 flex flex-col min-h-0 border-r border-surface-200/50 bg-surface-50" }, children)));
};
const SidebarHeader = props => {
    const { children, className } = props;
    return (React.createElement("div", { className: twMerge('flex items-center flex-shrink-0 px-4 py-5', className) }, children));
};
const SidebarContent = props => {
    const { children, className } = props;
    return (React.createElement("div", { className: twMerge('flex-1 flex flex-col pb-4 overflow-y-auto', className) }, children));
};
const SidebarFooter = props => {
    const { children, className } = props;
    return (React.createElement("div", { className: twMerge('flex-shrink-0 flex border-t border-surface-200/50 p-4', className) }, children));
};
Sidebar.Header = SidebarHeader;
Sidebar.Content = SidebarContent;
Sidebar.Footer = SidebarFooter;
//# sourceMappingURL=Sidebar.js.map